import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiChevronRight } from 'react-icons/fi';
import { SidebarData } from '../SideBar/SidebarData';
import './Breadcrumbs.css';

const findTrail = (pathname) => {
  for (const group of SidebarData) {
    for (const item of group.items) {
      if (item.children) {
        const child = item.children.find((c) => c.link === pathname);
        if (child) return [group.section, item.titre, child.titre];
      } else if (item.link === pathname) {
        return [group.section, item.titre];
      }
    }
  }
  return null;
};

const Breadcrumbs = () => {
  const location = useLocation();
  const trail = location.pathname === '/admin' ? ['Tableau de bord'] : findTrail(location.pathname);

  if (!trail) return null;

  return (
    <nav className="hd-admin-breadcrumbs" aria-label="Fil d'Ariane">
      <Link to="/admin">Admin</Link>
      {trail.map((segment, index) => (
        <React.Fragment key={segment + index}>
          <FiChevronRight />
          <span className={index === trail.length - 1 ? 'is-current' : ''}>{segment}</span>
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumbs;
